import { TimetableTemplate } from '@wui/common-library'
import { defineStore } from 'pinia'

import { useSettingsApi } from '../api'

export const useStoreSettingsTimetable = defineStore('timetable', {
  state: () => ({
    templates: [] as TimetableTemplate[],
  }),

  actions: {
    async loadTemplates () {
      const api = useSettingsApi()
      const { data } = await api.getTimetableTemplates()

      this.templates = data
    },
  },
})
